var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-footer',{staticClass:"footer"},[_c('p',{staticStyle:{"margin":"0","opacity":"0.6"}},[_vm._v("2026 杭州麦田熊科技有限公司")])])
}
var staticRenderFns = []

export { render, staticRenderFns }